// src/TermsOfService.jsx

import React from 'react';

const TermsOfService = () => {
  return (
    <div className="relative bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-blue-950 text-gray-800 dark:text-gray-200 min-h-screen p-4 sm:p-8 overflow-hidden">
      {/* Background Animated Shapes */}
      <div className="absolute top-0 -left-4 w-72 h-72 bg-purple-300 dark:bg-purple-700 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
      <div className="absolute top-0 -right-4 w-72 h-72 bg-yellow-300 dark:bg-yellow-700 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
      <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-300 dark:bg-pink-700 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>

      <div className="relative z-10 max-w-4xl mx-auto bg-white dark:bg-gray-800 p-6 sm:p-10 rounded-lg shadow-2xl">
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-4 sm:mb-6 text-center text-[#1C74BB] dark:text-blue-400">
          Terms of Service
        </h1>
        <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400 text-center mb-8">
          Last Updated: January 03, 2025
        </p>

        <section className="mb-8">
          <p className="mb-4 text-base sm:text-lg">
            These Terms of Service govern your use of <span className="font-semibold text-[#1C74BB] dark:text-blue-400">Dynamic Softlink’s</span> products and services, including access to the WhatsApp Business API integration.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            1. Agreement to Terms
          </h2>
          <p className="mb-4">
            By accessing or using our services, you agree to comply with these Terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            2. Use of Services
          </h2>
          <p className="mb-4">
            Dynamic Softlink provides IT services, custom APIs, and software products. You must use them in accordance with applicable laws and Meta’s policies.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            3. Account Responsibilities
          </h2>
          <p className="mb-4">
            You are responsible for maintaining the confidentiality of your credentials and for all activity under your account.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            4. Payments
          </h2>
          <p className="mb-4">
            If applicable, all services are billed monthly/yearly. Non-payment may result in service suspension.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            5. Prohibited Conduct
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Send spam</li>
            <li>Violate Meta’s API rules</li>
            <li>Conduct unlawful activity</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            6. Termination
          </h2>
          <p>
            We may suspend or terminate access for violations of these terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            7. Limitation of Liability
          </h2>
          <p>
            We are not liable for any indirect, incidental, or consequential damages.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            8. Indemnity
          </h2>
          <p>
            You agree to indemnify and hold Dynamic Softlink harmless from any legal claims related to your use of the services.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            9. Governing Law
          </h2>
          <p>
            These terms are governed by the laws of INDIA/GUJARAT.
          </p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-[#1C74BB] dark:text-blue-400">
            10. Contact
          </h2>
          <address className="not-italic space-y-2">
            <p>
              📍 Dynamic Softlink, 402, Empire State Building, Ring Rd, near Udhna Darwaja, Maan Darwaja, Rustampura, Surat, Gujarat 395002
            </p>
            <p>
              📧 <a href="mailto:info@dynamicsoftlink.com" className="text-[#1C74BB] dark:text-blue-400 hover:underline">info@dynamicsoftlink.com</a>
            </p>
          </address>
        </section>
      </div>    
    </div>
  );
};

export default TermsOfService;